import React from "react";
import PageBanner from "../../components/TermsPageComponents/PageBanner";
import { pgImg13 } from "../../components";

function EthicalHackingForBeginners() {
  return (
    <>
      <section id="securityServicesPage" className="securityServicesPage">
        <div className="pagesBanner">
          <PageBanner PageTitle="Ethical Hacking For Beginners" />

          <div className="shapeSvg">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15002 2408">
              <g id="Layer_x0020_1">
                <metadata id="CorelCorpID_0Corel-Layer" />
                <path
                  className="fil0"
                  d="M14999.66 160.41l0 2250.5 -15002 0 0 -2408.48c4.48,15.46 34.05,38.31 47.09,51.36 18.3,18.3 33.31,33.31 51.61,51.61l377.15 322.94c339.34,254.69 723.38,451.6 1129.12,576.25 740.24,227.38 1518.28,209.44 2250.74,-34.78 297.55,-99.2 684.02,-289.57 933.07,-476.11 87.62,-65.63 227.27,-165.69 307.34,-240.17 31.42,-29.23 114.35,-99.39 131.22,-124.58 20,4.66 99.59,47.55 124.17,59.83 42.41,21.2 81.55,40.72 122.67,61.33l125.61 58.39c133.82,59.52 249.76,112.63 391.76,169.22 238.34,95 587.91,216.82 832.54,284.94 200.63,55.86 382.28,106.97 590.69,154.3 1557.59,353.7 3775.68,425.94 5382.01,17.95 25.54,-6.48 49.29,-10.39 73.59,-16.17l373.43 -93.31c198.88,-54.19 343.18,-97.87 536.61,-159.02l312.66 -109.2c47.88,-17.88 90.5,-33.57 136.53,-51.96 82.88,-33.12 316.41,-125.5 392.57,-163.92l128.78 -59.7c23.6,-10.77 225.99,-115.13 251.04,-121.22z"
                />
              </g>
            </svg>
          </div>
        </div>
      </section>
      <section
        id="securityServicesContentWrap"
        className="securityServicesContentWrap"
      >
        <div className="container">
          <div className="col-md-12 col-12">
            <div className="contentWrap">
              <div className="row">
                <div className="col-md-7">
                  <p>
                    Ethical hacking, as widely understood, is a practice
                    employed to assess the security of a system without
                    malicious intent. Many companies encounter security issues,
                    often involving unauthorized access and data breaches.
                    Ethical hackers play a crucial role in preventing such
                    incidents, making it a valuable skill for IT professionals
                    in addressing security challenges.
                  </p>
                  <p>
                    For those seeking ethical hacking training in Mumbai, you've
                    come to the right place. Version Next Technologies not only
                    imparts knowledge but provides hands-on experience. Our
                    ethical hacking course offers an objective evaluation of a
                    business's security, emphasizing the importance of
                    identifying and rectifying vulnerabilities promptly. This
                    course equips you with the expertise needed to excel in this
                    field.
                  </p>
                  <p>
                    Ethical hacking is indispensable for security officers,
                    network administrators, firewall administrators, auditors,
                    security professionals, and anyone interested in this
                    domain. Students aspiring to build a career in this field
                    will also benefit greatly. Our course is meticulously
                    designed to transform you into an expert.
                  </p>
                  <p>
                    Few hacking classes in Mumbai match our dedication. Our
                    faculty comprises highly knowledgeable experts well-versed
                    in both the subject matter and effective teaching methods.
                    As one of the premier ethical hacking institutes in Mumbai,
                    we spare no effort in ensuring you acquire comprehensive
                    knowledge and skills in ethical hacking within the shortest
                    time frame possible.
                  </p>
                </div>
                <div className="col-md-5">
                  <div className="pageImgWrap">
                    <img src={pgImg13} alt="Ethical Hacking For Beginners" />
                  </div>
                </div>
              </div>
            </div>
            <div className="contentWrap">
              <div className="sedtionTitle">
                <h4>Course Outline</h4>
              </div>
              <div className="table-responsive courseTable">
                <table className="table">
                  <thead>
                    <tr>
                      <th>Title</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>1. Introduction to hacking &amp; Process</td>
                      <td>15. Website Security (SQL &amp; XSS testing)</td>
                    </tr>
                    <tr>
                      <td>
                        2. Network Basics, Operating systems and Databases
                      </td>
                      <td>16. DDOS attacks, buffer and stack overflow</td>
                    </tr>
                    <tr>
                      <td>3. Concepts of TCP/IP and OSI model and process</td>
                      <td>
                        17. ATM, Credit card and Debit card attacks &amp;
                        Security
                      </td>
                    </tr>
                    <tr>
                      <td>4. Detail IP&amp;MAC - spoofing &amp; security</td>
                      <td>18. Live demonstration on dedicated server</td>
                    </tr>
                    <tr>
                      <td>5. Foot-printing/Information gathering</td>
                      <td>19. USB hacking technique / switch blades</td>
                    </tr>
                    <tr>
                      <td>6. Web search/Google hacking</td>
                      <td>20. Protocols vulnerabilities</td>
                    </tr>
                    <tr>
                      <td>7. Scanning &amp; types</td>
                      <td>21. Email Hacking and security</td>
                    </tr>
                    <tr>
                      <td>8. Password cracking and system security</td>
                      <td>
                        22. Virus, Trojans, worms, Ransomwares and security
                      </td>
                    </tr>
                    <tr>
                      <td>
                        9. Brief of Kali Linux &amp; pentesting with Kali Linux
                      </td>
                      <td>23. Reverse engineering</td>
                    </tr>
                    <tr>
                      <td>10. Social engineering attacks &amp; security</td>
                      <td>24. Mobile E-hacking and security</td>
                    </tr>
                    <tr>
                      <td>11. Cryptography basics for the aspiring hacker</td>
                      <td>25. Wi-Fi Security</td>
                    </tr>
                    <tr>
                      <td>12. Steganography (audio, video,text and image)</td>
                      <td>26. Physical security threats</td>
                    </tr>
                    <tr>
                      <td>13. Firewalls, IDS/IPS and Honeypots</td>
                      <td>27. Understanding ISO 27001 standards</td>
                    </tr>
                    <tr>
                      <td>14. Owasp Top 10</td>
                      <td>28. Cyber laws in India</td>
                    </tr>
                  </tbody>
                </table>
                <b className="boldTxt">
                  Each of the below module contains sub-topics, for complete
                  details contact us.
                </b>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default EthicalHackingForBeginners;
